import { STRectAlignment } from '@tencent/slide-sdk-model';
import { EEffectAlgn } from '@src/slide/domain/ui-model/element-modeles/property/effect/effect.interface';

// 原点 - sdk对上层类型映射
export const ALGN_VER3_MAP = new Map([
    [STRectAlignment?.tl, EEffectAlgn.TL],
    [STRectAlignment?.t, EEffectAlgn.T],
    [STRectAlignment?.tr, EEffectAlgn.TR],
    [STRectAlignment?.l, EEffectAlgn.L],
    [STRectAlignment?.ctr, EEffectAlgn.CTR],
    [STRectAlignment?.r, EEffectAlgn.R],
    [STRectAlignment?.bl, EEffectAlgn.BL],
    [STRectAlignment?.b, EEffectAlgn.B],
    [STRectAlignment?.br, EEffectAlgn.BR],
]);
